import React from 'react'
import _ from 'lodash/fp'
import { connect } from 'react-redux'
import Select from 'react-select'

import Spinner from '@fe/ui/Spinner'

// Material UI things
import withStyles from '@material-ui/core/styles/withStyles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import { ClubsMap } from './ClubsMap'
import { ClubsList } from './ClubsList'
import { haversineDistance } from '../../util/map'

import * as ClubsReducer from '../../reducers/clubs'

const styles = theme => ({
  widthCalc: {
    width: '100vw',
    [theme.breakpoints.up('md')]: {
      width: 'calc(100vw - 240px)'
    }
  }
})

const sortings = [
  { value: ['name', 'asc'], label: 'Name, asc.' },
  { value: ['name', 'desc'], label: 'Name, desc.' },
  { value: ['position', 'asc'], label: 'Nearest' }
]

class Clubs extends React.Component {
  state = {
    search: '',
    mapMode: true,
    position: null,
    sorting: { value: ['position', 'asc'], label: 'Nearest' },
    onlyCustomers: true
  }

  UNSAFE_componentWillMount () {
    this.props.getClubs()
    navigator.geolocation.getCurrentPosition((pos) => {
      const position = { latitude: pos.coords.latitude, longitude: pos.coords.longitude }
      this.setState({ position })
    })
  }

  render () {
    const { clubsSize } = this.props
    const clubs = this.props.sortClubs(
      _.flow(_.get('value'), _.first)(this.state.sorting),
      _.flow(_.get('value'), _.last)(this.state.sorting),
      this.state.position,
      this.state.onlyCustomers,
      this.state.search
    )
    const barHeight = 80
    if (clubsSize === 0) {
      return <Spinner title='Loading Clubs' />
    }
    return (
      <>
        <Paper
          className={this.props.classes.widthCalc}
          style={{ position: 'fixed', zIndex: 2, top: 64, height: barHeight, padding: 8 }}
        >
          <Grid container spacing={1}>
            <Grid item xs={6} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-end' }}>
              {!this.state.mapMode && (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', maxWidth: 300, marginRight: 8 }}>
                  <div>Order by</div>
                  <Select
                    onChange={(option) => this.setState({ sorting: option })}
                    value={this.state.sorting}
                    options={_.values(sortings)}
                  />
                </div>
              )}
              <TextField
                label='Search Clubs'
                value={this.state.search}
                placeholder='Search club names'
                onChange={(e) => this.setState({ search: e.target.value })}
              />
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!this.state.onlyCustomers}
                    onChange={(e, checked) => this.setState({ onlyCustomers: !checked })}
                  />
                }
                label='Include basic clubs'
              />
              {!this.state.mapMode && <Button onClick={() => window.scrollTo(0, 0)}>Scroll to top</Button>}
              {this.state.mapMode && <Button onClick={() => this.setState({ mapMode: false })}>Show on list</Button>}
              {!this.state.mapMode && <Button onClick={() => this.setState({ mapMode: true })}>Show on map</Button>}
            </Grid>
          </Grid>
        </Paper>
        {!this.state.mapMode && (
          <ClubsList
            clubs={clubs}
            barHeight={barHeight}
            classes={this.props.classes}
            sorting={this.state.sorting}
            position={this.state.position}
          />
        )}
        {this.state.mapMode && (
          <ClubsMap
            classes={this.props.classes}
            position={this.state.position}
            clubs={clubs}
          />
        )}
      </>
    )
  }
}

export default _.compose(
  connect(
    (s, ownProps) => {
      const clubs = ClubsReducer.selectors.clubs(s)
      const activeClubs = _.flow(_.omitBy({ active: false }))(clubs)
      return {
        clubsSize: _.size(activeClubs),
        sortClubs: (field, order, position = false, onlyCustomers = true, searchString = '') => _.flow(
          (clubs) => {
            if (!onlyCustomers) {
              return clubs
            }
            return _.omitBy({ customer: false }, clubs)
          },
          (clubs) => {
            if (field !== 'position' || !position) {
              return _.orderBy([field], [order], clubs)
            } else {
              return _.sortBy((club) => haversineDistance(position, _.get('position', club)), clubs)
            }
          },
          (clubs) => {
            if (_.size(searchString) < 4 || !searchString) {
              return clubs
            }
            return _.filter(
              (club) => {
                const name = _.get('name', club)
                return _.includes(_.toLower(searchString), _.toLower(name))
              }, clubs)
          }
        )(activeClubs)
      }
    },
    (d, ownProps) => {
      return {
        getClubs: () => d(ClubsReducer.actions.clubsRequest())
      }
    }
  ),
  withStyles(styles)
)(Clubs)
